import styled from "styled-components";

export const SecurityScreenWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100vh;
	background-color: #f5f5f5;
	 padding: 0;
	 margin: 0;
`;

export const Title = styled.h1`
    font-size: 1.4rem;
    font-weight: 600;
    color: #54778E;
    font-family: 'Montserrat', sans-serif;
`;

export const Subtitle = styled.h3`
	 font-size: 1rem;
	 font-weight: 400;
	 color: #8f8f8f;
	 font-family: 'Montserrat', sans-serif;
`;